document.addEventListener('DOMContentLoaded', () => {
  const descriptionBlocks = document.querySelectorAll(
    '.product-info__block-item[data-block-id="description"] .prose'
  );

  descriptionBlocks.forEach((block) => {
    const headings = Array.from(block.querySelectorAll('h4'));

    headings.forEach((heading) => {
      const title = heading.textContent.trim().toUpperCase();

      if (title !== 'DETAILS' && title !== 'SIZE AND FIT') return;

      const accordion = document.createElement('details');
      accordion.className = 'product-description-accordion';

      const summary = document.createElement('summary');
      summary.textContent = heading.textContent.trim();
      accordion.appendChild(summary);

      const contentWrap = document.createElement('div');
      contentWrap.className = 'product-description-accordion__content';

      let sibling = heading.nextElementSibling;

      while (sibling) {
        const next = sibling.nextElementSibling;

        if (sibling.tagName && sibling.tagName.toUpperCase() === 'H4') break;

        contentWrap.appendChild(sibling);
        sibling = next;
      }

      accordion.appendChild(contentWrap);
      heading.replaceWith(accordion);
    });
  });
});